import React, { useEffect, useState, useRef } from 'react';

const statsData = [
  { number: '3', label: 'Strategic Pillars' },
  { number: '100%', label: 'South African\nHigh-Tech' },
  { number: '2016', label: 'Founded' },
  { number: 'B2G', label: 'Sovereign\nFocus' },
];

const Stats = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="relative py-16 md:py-24 lg:py-32 bg-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-12 md:mb-16 lg:mb-24">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#3eb5a0] mb-4">
            Facts and Figures
          </h2>
          <p className="text-xl md:text-2xl text-white/70 font-light">We're good with numbers</p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 lg:gap-20">
          {statsData.map((stat, index) => (
            <div
              key={index}
              className={`text-left transform transition-all duration-700 delay-${index * 100} ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <div className="mb-4 md:mb-6">
                <span className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#3eb5a0] block">
                  {stat.number}
                </span>
              </div>
              <p className="text-base md:text-lg text-white/70 font-light whitespace-pre-line leading-snug">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;